import React from "react";
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import {
  deleteDVIRTemplate,
  resetShowDeleteTemplateConfirmationModal,
} from "../../dvirSlice";
import "./DeleteTemplateModal.scss";

export function DeleteTemplateModal() {
  const dispatch = useAppDispatch();
  const templateToDelete = useAppSelector(
    (state) => state.dvir.showDeleteTemplateConfirmationModal
  );
  const deleteAPI = useAppSelector((state) => state.dvir.deleteDVIRTemplate);

  const handleConfirmDelete = () => {
    if (templateToDelete) {
      dispatch(deleteDVIRTemplate(templateToDelete.id));
    }
  };

  const handleClose = () => {
    dispatch(resetShowDeleteTemplateConfirmationModal());
  };

  if (!templateToDelete) return null;

  const hasQuestions =
    templateToDelete.templateQuestions &&
    templateToDelete.templateQuestions.length > 0;
  const questionCount = templateToDelete.templateQuestions?.length || 0;

  const getTemplateTypeLabel = (type: string): string => {
    switch (type) {
      case "pre_trip":
        return "Pre-Trip";
      case "post_trip":
        return "Post-Trip";
      default:
        return type;
    }
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div
        className="delete-template-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>{hasQuestions ? "Cannot Delete Template" : "Delete Template"}</h3>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          {hasQuestions ? (
            <div className="usage-warning">
              <div className="warning-icon">⚠️</div>
              <div className="warning-content">
                <p className="warning-title">
                  This template contains questions
                </p>
                <p className="warning-message">
                  This template contains{" "}
                  <strong>
                    {questionCount} question
                    {questionCount === 1 ? "" : "s"}
                  </strong>{" "}
                  and cannot be deleted.
                </p>
                <p className="warning-suggestion">
                  To delete this template, you must first remove all questions
                  from it.
                </p>
              </div>
            </div>
          ) : (
            <div className="delete-confirmation">
              <div className="danger-icon">🗑️</div>
              <div className="confirmation-content">
                <p className="confirmation-title">
                  Are you sure you want to delete this template?
                </p>
                <div className="template-preview">
                  <div className="template-name">"{templateToDelete.name}"</div>
                  <div className="template-meta">
                    <span className="template-type">
                      Type:{" "}
                      {getTemplateTypeLabel(templateToDelete.templateType)}
                    </span>
                    <span className="divider">•</span>
                    <span
                      className={`status ${
                        templateToDelete.isActive ? "active" : "inactive"
                      }`}
                    >
                      {templateToDelete.isActive ? "Active" : "Inactive"}
                    </span>
                  </div>
                  {templateToDelete.description && (
                    <div className="template-description">
                      {templateToDelete.description}
                    </div>
                  )}
                </div>
                <p className="confirmation-warning">
                  This action cannot be undone. The template will be permanently
                  removed from the system.
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={deleteAPI.loading}
          >
            {hasQuestions ? "Close" : "Cancel"}
          </button>
          {!hasQuestions && (
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleConfirmDelete}
              disabled={deleteAPI.loading}
            >
              {deleteAPI.loading ? "Deleting..." : "Delete Template"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
